export default __webpack_public_path__ + "6fcccaba1902e08658c747fac11dfd86.png";